<template>
  <div style="padding:8px">
    <div >
      <!-- tab页头 -->
      <div>
        <el-tabs v-model="activeTab" @tab-click="handleClick">
          <el-tab-pane :label="$t('runState.operDeal')" name="operDeal">
            <operDeal :size="size" :isClicked="operDealClick"></operDeal>
          </el-tab-pane>
          <el-tab-pane :label="$t('runState.daySta')" name="daySta">
            <daySta :size="size" :isClicked="dayStaClick"></daySta>
          </el-tab-pane>
          <el-tab-pane :label="$t('runState.monthSta')" name="monthSta">
            <monthSta :size="size" :isClicked="monthStaClick"></monthSta>
          </el-tab-pane>
          <el-tab-pane :label="$t('runState.monthRate')" name="monthRate">
            <monthRate :size="size" :isClicked="monthRateClick"></monthRate>
          </el-tab-pane>
          <el-tab-pane :label="$t('runState.mileageSta')" name="mileageSta">
            <mileageSta :size="size" :isClicked="mileageStaClick"></mileageSta>
          </el-tab-pane>
          <el-tab-pane :label="$t('runState.daySummary')" name="daySummary">
            <daySummary :queryType="0" :size="size" :DealOptions="DealOptions" :mulSelectLoading="mulSelectLoading" :isClicked="daySummaryClick"></daySummary>
          </el-tab-pane>
          <el-tab-pane :label="$t('runState.monthSummary')" name="monthSummary">
            <daySummary :queryType="1" :size="size" :DealOptions="DealOptions" :mulSelectLoading="mulSelectLoading" :isClicked="monthSummaryClick"></daySummary>
          </el-tab-pane>
          <el-tab-pane :label="$t('runState.summary')" name="Summary">
            <daySummary :queryType="2" :size="size" :DealOptions="DealOptions" :mulSelectLoading="mulSelectLoading" :isClicked="SummaryClick"></daySummary>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import allSummary from '@/views/statistics/operationalData/allSummary'
import monthSummary from '@/views/statistics/operationalData/monthSummary'
import mileageSta from '@/views/statistics/operationalData/mileageSta'
import monthRate from '@/views/statistics/operationalData/monthRate'
import daySummary from '@/views/statistics/operationalData/daySummary'
import monthSta from '@/views/statistics/operationalData/monthSta'
import daySta from '@/views/statistics/operationalData/daySta'
import operDeal from '@/views/statistics/operationalData/operDeal'
import datetimerange from './components/datetimerange.vue';
import { mapState } from 'vuex';
export default {
  name: "RunStateByVehicle",
  components:{datetimerange,operDeal,daySta,monthSta,daySummary,monthRate,mileageSta,monthSummary,allSummary},
  data(){
    return{
      monthStaClick:false,
      monthRateClick:false,
      mileageStaClick:false,
      daySummaryClick:false,
      monthSummaryClick:false,
      SummaryClick:false,
      operDealClick:false,
      dayStaClick:false,
      loading:{
        l0:true,
        l1:true,
        l2:true,
        l3:true
      },
      DealOptions:[[],[],[],[]],
      mulSelectLoading:false,
      datePickerOptions: {
          disabledDate(date) {
              return date > new Date(new Date().getTime() -  24 * 60 * 60 * 1000)
          }
      },

      activeTab:"operDeal",
      timeRange:[],
    }
  },
  computed:{
    size() {
      return this.$store.getters.size
    },
    ...mapState({
      operator: state => state.user.operator,
    }),
  },
  watch:{
    // loading:{
    //   handler(newVal,oldVal){
    //     console.log(newVal);
    //     this.mulSelectLoading = (!this.loading.l0 && !this.loading.l1 && !this.loading.l2 && !this.loading.l3) ? false : true;
    //     console.log(this.mulSelectLoading)
    //   },
    //   immediate:true
    // }
    'loading.l0':function(newVal,oldVal){
      // console.log("l0变化了",this.mulSelectLoading);
      this.mulSelectLoading = (!this.loading.l0 && !this.loading.l1 && !this.loading.l2 && !this.loading.l3) ? false : true;
    },
    'loading.l1':function(newVal,oldVal){
      // console.log("l1变化了",this.mulSelectLoading);
      this.mulSelectLoading = (!this.loading.l0 && !this.loading.l1 && !this.loading.l2 && !this.loading.l3) ? false : true;
    },
    'loading.l2':function(newVal,oldVal){
      // console.log("l2变化了",this.mulSelectLoading);
      this.mulSelectLoading = (!this.loading.l0 && !this.loading.l1 && !this.loading.l2 && !this.loading.l3) ? false : true;
    },
    'loading.l3':function(newVal,oldVal){
      // console.log("l3变化了",this.mulSelectLoading);
      this.mulSelectLoading = (!this.loading.l0 && !this.loading.l1 && !this.loading.l2 && !this.loading.l3) ? false : true;
    },
    activeTab(newVal,oldVal){
      if(newVal == "daySummary" || newVal == "monthSummary" || newVal == "Summary"){
        this.$store.dispatch('app/closeSideBar');
      }else{
        this.$store.dispatch('app/openSideBar');
      }
    }
  },
  methods:{
    // tabs点击再进行初次加载
    handleClick(tabs){
      const {index} = tabs;
      console.log(index);
      switch(index){
        case "0":
          break;
        case "1":
          this.dayStaClick = true;
          break;
        case "2":
          this.monthStaClick = true;
          break;
        case "3":
          this.monthRateClick = true;
          break;
        case "4":
          this.mileageStaClick = true;
          break;
        case "5":
          this.daySummaryClick = true;
          break;
        case "6":
          this.monthSummaryClick = true;
          break;
        case "7":
          this.SummaryClick = true;
          break;
      }
    },
    getLevel(newVal){
      this.mulSelectLoading = true;
      this.loading.l0 = this.loading.l1 = this.loading.l2 = this.loading.l3 = true;
      switch(newVal){
        case 0: //总公司
          this.$api.headOfficeSearch({
            companyID:this.operator.CompanyId
            // companyID:26071
            // companyID:5657
          })
          .then((res) =>{
            if(res.headOfficeInfo){
              // console.log(0);
              // this.DealOptions = [];
              this.DealOptions[0].push({
                value: this.operator.CompanyId,
                // value: 5657,
                label: res.headOfficeInfo.corporateName
              }
              );
            }
            this.loading.l0 = false;
          })
          .catch((e)=>{
            this.loading.l0 = false;
          })
          
        case 1: //分公司
          this.$api.queryBranchInfo({
            companyID:this.operator.CompanyId  //26071
            // companyID:5657
          })
          .then((res) =>{
            if(res.data){
              // console.log(1);
              // this.DealOptions = [];
              this.allGroupIDs = "";
              res.data.forEach(element => {
                this.DealOptions[1].push({
                  value: element.branchofficeID,
                  label: element.branchname,
                });
                this.allGroupIDs +=element.branchofficeID + ",";//暂定
              });
              this.allGroupIDs = this.allGroupIDs.substring(0,this.allGroupIDs.length-1);
              // this.$emit("getLevel",this.levelDeal);
            }
            this.loading.l1 = false;
          })
          .catch((e)=>{
            this.loading.l1 = false;
          })
          
        case 2: //车队
          this.$api.queryFleetInfo({
            companyID:this.operator.CompanyId
            // companyID:26071
            // companyID:5657
          })
          .then((res) =>{
            if(res.data){
              // console.log(2);
              // this.DealOptions = [];
              res.data.forEach(element => {
                this.DealOptions[2].push({
                  value: element.fleetID,
                  label: element.fleetname,
                }
                )
              });
            }
            this.loading.l2 = false;
          })
          .catch((e)=>{
            this.loading.l2 = false;
          })
          
        case 3: //线路
          this.$api.queryRouteList({
            companyID:this.operator.CompanyId
            // companyID:26071
            // companyID:5657
          })
          .then((res) =>{
            if(res.data){
              // console.log(3);
              // this.DealOptions = [];
              res.data.forEach(element => {
                this.DealOptions[3].push({
                  value: element.lineID,
                  label: element.linename,
                }
                )
              });
            }
            this.loading.l3 = false;
          })
          .catch((e)=>{
            this.loading.l3 = false;
          })
          break;
      }
      // console.log(this.DealOptions);
      // this.$emit("getLevel",this.DealOptions[0]);
      
    },
  },
  mounted() {
    // this.handleQuery();
    this.getLevel(0);
  },
  destroyed() {
    this.$store.dispatch("app/openSideBar");
  },
}
</script>
<style lang="scss" scoped>

</style>